// Mercurial — Live-Ops Developer Platform (Onyx · Cyan · Signal-green)
export const META = { brand: 'mercurial', tag: '/* live-ops platform · v8.4.2 */', est: '2019' };
export const ROUTES = [
  { id: 'home', label: 'console', cmd: 'cd ~' },
  { id: 'modules', label: 'modules', cmd: 'ls -la' },
  { id: 'status', label: 'status', cmd: 'ping' },
  { id: 'pricing', label: 'pricing', cmd: 'plan --tier' },
];

export const REGIONS = [
  { code: 'us-east-1', city: 'Ashburn, VA', latency: '11ms', state: 'OPERATIONAL' },
  { code: 'us-west-2', city: 'Hillsboro, OR', latency: '14ms', state: 'OPERATIONAL' },
  { code: 'eu-west-1', city: 'Dublin, IE', latency: '22ms', state: 'OPERATIONAL' },
  { code: 'eu-central-1', city: 'Frankfurt, DE', latency: '24ms', state: 'DEGRADED' },
  { code: 'ap-southeast-1', city: 'Singapore', latency: '38ms', state: 'OPERATIONAL' },
  { code: 'ap-northeast-1', city: 'Tokyo, JP', latency: '41ms', state: 'OPERATIONAL' },
];

export const MODULES = [
  { code: '@mc/edge', name: 'Edge Runtime', d: 'Deploy serverless functions to 18 regions in under 60 seconds. Bring your own Node, Python, or Bun.', endpoints: 4, rps: '120k / pod', tag: 'compute' },
  { code: '@mc/queue', name: 'Job Queue', d: 'Durable, idempotent, FIFO. SLA 99.99% with replay-from-cursor and deadletter inspection.', endpoints: 6, rps: '8k / sec', tag: 'data' },
  { code: '@mc/secrets', name: 'Vault', d: 'Encrypted-at-rest secret store with KMS-rotated keys. SOC2 Type II + FIPS 140-2.', endpoints: 5, rps: '24k / sec', tag: 'security' },
  { code: '@mc/observe', name: 'Observability', d: 'Logs, traces, and metrics in one panel. OpenTelemetry-native. 30-day retention free.', endpoints: 7, rps: '1.6M events / min', tag: 'ops' },
];

export const DEPLOY_LOG = [
  { t: '09:42:18', sev: 'OK', msg: 'main.dispatch · build #4128 deployed · us-east-1 · 41s' },
  { t: '09:41:02', sev: 'OK', msg: 'platform.queue · cursor advanced to 81,442,001' },
  { t: '09:39:55', sev: 'WARN', msg: 'eu-central-1 · cold start latency above SLO (p99: 412ms)' },
  { t: '09:38:14', sev: 'OK', msg: 'main.api · 200 OK · 1.4M req/min · all green' },
];

export const UPTIME_30D = Array.from({ length: 30 }, (_, i) => {
  // deterministic but speckled — most green, a few amber
  const dips = [4, 11, 17, 22];
  return dips.includes(i) ? 'D' : 'O';
});

export const PLANS = [
  { tier: 'developer', price: '0', unit: '/forever', for: 'side projects · 1 seat', items: ['1M edge invocations / mo', 'Community support', '24h log retention', '@mc/edge core'] },
  { tier: 'team', price: '290', unit: '/mo', for: 'teams of 5 — 25', items: ['25M edge invocations / mo', 'Slack support · 4h SLA', '14d log retention', 'All four modules', 'SSO + audit log'], featured: true },
  { tier: 'scale', price: 'custom', unit: '/contract', for: 'production at scale', items: ['Unlimited invocations', 'Dedicated SRE · 1h SLA', '90d log retention', 'Private VPC + BYOC', 'SOC2 + HIPAA + FedRAMP'] },
];
